import React from "react";
var __jsx = React.createElement;
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import SearchableGrid from "@/pages/serviceCenters/ServiceCentersComponents/SearchableGrid/SearchableGrid";
import stl from "./SCPopUp.module.css";
var SCPopUp = function SCPopUp(_ref) {
  var _popUpData$data;
  var popUpData = _ref.popUpData,
    showPopUp = _ref.showPopUp,
    setShowPopUp = _ref.setShowPopUp;
  return /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    },
    className: stl.customPopUp
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.popupContainer
  }, /*#__PURE__*/React.createElement("h3", null, popUpData.popUpTitle), /*#__PURE__*/React.createElement(SearchableGrid, {
    disabled: false,
    selectedValue: popUpData.selectedValue,
    data: popUpData === null || popUpData === void 0 ? void 0 : (_popUpData$data = popUpData.data) === null || _popUpData$data === void 0 ? void 0 : _popUpData$data.map(function (val) {
      return {
        key: val.id,
        name: val.name,
        image: val === null || val === void 0 ? void 0 : val.logo
      };
    }),
    getData: popUpData.getData,
    minLengthForSearch: popUpData.minLengthForSearch,
    name: popUpData.name,
    label: popUpData.label
  })));
};
export default SCPopUp;